import { FC, PropsWithChildren } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type CampaignStepTitleProps = {
  title: string;
  description?: string;
  classNames?: {
    wrapper?: string;
    title?: string;
  };
} & PropsWithChildren;

export const CampaignStepTitle: FC<CampaignStepTitleProps> = ({ title, description, classNames, children }) => {
  const { t } = useTranslation('ALL');
  const titleKey = `ALL:${title}` as any;

  return (
    <header className={twMerge('grid gap-5', classNames?.wrapper)}>
      <h2 className='text-pretty text-6xl font-semibold tracking-[-0.075rem] first-letter:capitalize'>
        <Trans
          i18nKey={titleKey}
          components={{
            blueWord: <span className='text-brand-600'></span>,
            newLine: <br />,
          }}
        />
      </h2>
      <div className='flex items-center gap-1.5'>
        <p className='first-letter:capitalize'>{t(description as any)}</p>
        {children}
      </div>
    </header>
  );
};
